import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { DashboardReal } from '../components/dashboard-real'
import { AuthService } from '../services/auth-service'

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    if (typeof window === 'undefined') return
    // Verificação robusta da sessão (inclui expiração)
    const sessao = AuthService.verificarSessao()
    if (!sessao.isAuthenticated) {
      throw redirect({ to: '/' })
    }
  },
  component: DashboardComponent,
})

function DashboardComponent() {
  const navigate = useNavigate()
  const handleLogout = () => {
    navigate({ to: '/' })
  }

  return <DashboardReal onLogout={handleLogout} />
}
